/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { DEVICE } from "src/app/globalStyles";
import { CSSBall } from "src/components/UI/Loading/Spinners/SpinnerBall/CSSBall";
import { SpinnerWrapper } from "src/components/UI/Loading/Spinners/SpinnerBall/SpinnerWrapper";

export const InlineSpinner = () => {
  return (
    <InlineLoaderWrapper>
      <SpinnerWrapper scale={0.7}>
        <CSSBall />
      </SpinnerWrapper>
    </InlineLoaderWrapper>
  );
};

const InlineLoaderWrapper = styled.div`
  height: 70.5px;
  padding: 22px;
  margin-top: 22px;
  @media (max-width: ${DEVICE.small}) {
    padding-bottom: 44px;
  }
`;
